/**
 * CM-API IpWhitelistGuard disguises denies as `invalid token`.
 * Non-login paths also send `code: force_logout` — use that to detect IP blocks
 * (Keycloak can succeed while /v1/me still fails).
 */
export async function isCmIpAllowlistDenied(
  fetchImpl: typeof fetch = fetch,
): Promise<boolean> {
  try {
    const res = await fetchImpl('/api/cm/v1/hierarchy/self', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: '{}',
    })
    if (res.status !== 401) return false
    const data = (await res.json().catch(() => ({}))) as { code?: string }
    return data.code === 'force_logout'
  } catch {
    return false
  }
}

export function cmIpAllowlistDeniedMessage(publicIp?: string | null): string {
  const ip = publicIp?.trim()
  const ipPart = ip ? ` Your public IP is ${ip}.` : ''
  return (
    `This network is not on the CM IP allowlist.${ipPart}` +
    ' Ask a CM admin to add it under Security → IP whitelist, then try again.'
  )
}
